import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

class ScrollToTop extends React.Component {

	componentDidMount() {
		if (this.props.location.hash) {
			let el = document.getElementById(this.props.location.hash.substr(1));
			if (el) {
				const main = document.getElementById('content');
				if (main) {
					main.scrollTop = el.offsetTop - main.offsetTop;
					main.scrollLeft = 0;
				} else {
					const body = window.document.body;
					body.scrollTop = el.offsetTop - body.offsetTop;
					body.scrollLeft = 0;
				}
			}
		}
	}

	componentDidUpdate(prevProps) {
		let scrollEl = window.document.body;
		let top = 0;

		if (this.props.scrollElId) {
			scrollEl = document.getElementById(this.props.scrollElId);
		}
		if (this.props.location.hash) {
			let el = document.getElementById(this.props.location.hash.substr(1));
			if (el) {
				top = el.offsetTop - scrollEl.offsetTop;
			}
		}

		scrollEl.scrollTop = top;
	}

	render() {
		return this.props.children;
	}
}

ScrollToTop.propTypes = {
	scrollElId: PropTypes.string, // Optional. ID of element to scroll. Default is window
	location: PropTypes.object.isRequired,
	children: PropTypes.object
};

export default withRouter(ScrollToTop);


// WEBPACK FOOTER //
// ./src/components/shared/ScrollToTop.js